import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import {
  GET_PAD_LIST,
  SET_PAD_LIST,
  GET_PAD_DETAIL,
  INSERT_PAD,
  UPDATE_PAD,
  DELETE_PAD,
} from '../constants/Pad';
import { getPadList, setPadList, setPadDetail } from '../actions/Pad';
import { showAuthMessage } from '../actions/Auth';
import { appIntl } from 'IntlGlobalProvider';

import ApiService from 'services/ApiService';
import utils from 'utils';

export function* callPadList() {
  yield takeEvery(GET_PAD_LIST, function* ({ payload }) {
    const url = '/pad/list';
    try {
      const { unitCd } = utils.userInfo();
      const params = { ...payload, unitCd };
      const list = yield call(ApiService.post, url, params);
      if (list) {
        yield put({ type: SET_PAD_LIST, data: list.data });
      }
    } catch (err) {
      yield put(showAuthMessage(err));
    }
  });
}

export function* callPadDetail() {
  yield takeEvery(GET_PAD_DETAIL, function* ({ payload }) {
    const url = `/pad/list/${payload}`;

    try {
      const list = yield call(ApiService.get, url, {});
      if (list) {
        yield put(setPadDetail(list.data));
      }
    } catch (err) {
      yield put(showAuthMessage(err));
    }
  });
}

export function* callInsertPad() {
  yield takeEvery(INSERT_PAD, function* ({ payload }) {
    try {
      const url = `/pad`;
      const res = yield call(ApiService.post, url, payload);
      console.log('res >>>', res);
      if (res.resultCode === 201) {
        utils.openNotificationWithIcon(
          'success',
          appIntl().formatMessage({ id: 'message.account.0000009' })
        );
        yield put(getPadList());
      }
    } catch (err) {
      yield put(showAuthMessage(err));
    }
  });
}

export function* callUpdatePad() {
  yield takeEvery(UPDATE_PAD, function* ({ payload }) {
    try {
      const { padSeq } = payload;
      const url = `/pad/${padSeq}`;
      const res = yield call(ApiService.patch, url, payload);
      console.log('res >>>', res);
      if (res.resultCode === 201) {
        utils.openNotificationWithIcon(
          'success',
          appIntl().formatMessage({ id: 'message.account.0000009' })
        );
        yield put(getPadList());
      }
    } catch (err) {
      yield put(showAuthMessage(err));
    }
  });
}

export function* callDeletePad() {
  yield takeEvery(DELETE_PAD, function* ({ payload }) {
    try {
      const { padSeq } = payload;
      const url = '/pad/' + padSeq;
      const params = {};
      const res = yield call(ApiService.delete, url, params);
      if (res.resultCode === 201) {
        utils.openNotificationWithIcon(
          'success',
          appIntl().formatMessage({ id: 'message.account.0000013' })
        );
        yield put(getPadList());
      }
    } catch (err) {
      yield put(showAuthMessage(err));
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(callPadList),
    fork(callPadDetail),
    fork(callInsertPad),
    fork(callUpdatePad),
    fork(callDeletePad),
  ]);
}
